export const arrayToIndexedObject = (arr: string[]): { [key: string]: number } =>
  arr.reduce(
    (acc, el, index) => {
      acc[el] = index;
      return acc;
    },
    {} as { [key: string]: number }
  );
